import {Component, ChangeDetectionStrategy} from '@angular/core';
import { NgClass } from "@angular/common";
import {TableSorterHeaderDirective} from "../../../directives/table-sorter/table-sorter-header.directive";

@Component({
  selector: 'app-table-sorter-header',
  imports: [
    NgClass
],
  templateUrl: './table-sorter-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './table-sorter-header.component.scss'
})
export class TableSorterHeaderComponent {
  protected content: string = '';
  protected sort: string | null = 'asc';

  tableSorterHeader: TableSorterHeaderDirective | null = null;

  setTableSorterHeader(tableSorterHeader: TableSorterHeaderDirective): void {
    this.tableSorterHeader = tableSorterHeader;
  }

  onClick(e: Event) {
    e.preventDefault();

    this.tableSorterHeader?.onChange(this.sort === 'asc' ? 'desc' : 'asc');
  }

  setSort(sort: string | null): void {
    this.sort = sort;
  }

  setContent(content: string): void {
    this.content = content;
  }
}
